/**
 * Prototype hash URLs (FE-01 FR-FE01-08, §6.3): `/app/#mapa` and friends land on the new path
 * routes. Path redirects (`/pagar/<token>`, `/estado`, …) are host rules (`build/hosting.ts`).
 */
const HASH_ROUTES: Record<string, string> = {
  mapa: "/app/map",
  sitios: "/app/sites",
  leads: "/app/leads",
  cambios: "/app/changes",
  mas: "/app/more",
  comisiones: "/app/more/commissions",
  galeria: "/app/more/gallery",
  medida: "/app/more/custom-page",
  referidos: "/app/more/referrals",
  manejo: "/app/drive",
  pagos: "/app/admin/payouts",
};

/** The new href for a prototype `/app/` URL, or null when it is not one. */
export function legacyAppTarget(pathname: string, hash: string, searchStr = ""): string | null {
  if (pathname !== "/app" && pathname !== "/app/") return null;
  const key = hash.replace(/^#/, "").toLowerCase();
  if (!key) return null;
  if (key === "registro") {
    const ref = new URLSearchParams(searchStr).get("ref");
    return ref ? `/app/register?ref=${encodeURIComponent(ref)}` : "/app/register";
  }
  return HASH_ROUTES[key] ?? null;
}
